import React, { useRef, useState, useEffect } from 'react'
import reducer from "../../store";
import withReducer from 'app/store/withReducer';
import { AgGridReact } from 'ag-grid-react';
import '../../../../../styles/ag-custom.css';
import 'ag-grid-enterprise';
import 'styles/ag-grid-header-style.css';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import 'ag-grid-community/styles/ag-theme-material.css';
import axios from "@fuse/utils/axios";
import lodash from "lodash"
import Tooltip from "@material-ui/core/Tooltip";
import { dateReformatTo_mmm_dd_yyyy } from '@fuse/utils/dateOperations'
import useToast from '@fuse/hooks/useToast';
import { useDispatch } from 'react-redux';
import { usePermission } from '@fuse/hooks';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import AgGridFilterGroupView from '@fuse/components/AgGridFilterGroupView';
import CustomFilter from '@fuse/components/AgGridFilterGroupView/components/CustomFilter';
import DeleteConfirmModal from 'helper/DeleteConfirm';

function CustomReportLayout() {
	const [reports, setReports] = useState(null)
	const [windowHeight, setWindowHeight] = useState(window.innerHeight - 330);
	const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
	const [reportData, setReportData] = useState(null);
	// const parentRef = useRef();
	const gridRef = useRef();
	const dispatch = useDispatch();
	const toast = useToast(dispatch);
	const { hasPermission } = usePermission()
	const viewReportPermission = hasPermission('view-report')
	const deleteReportPermission = hasPermission('delete-report')
	const [groupByArr, setGroupByArr] = useState([])
	const [rowGroupPanelShow, setRowGroupPanelShow] = useState('never');
	const [groupByHappen, setGroupByHappen] = useState(false)
	const fetchReport = () => {
		axios.get('/reports/view-reports')
			.then(results => {
				setReports(formatData(results.data.data))
				if (results.data.data?.length === 0) gridRef.current.api.showNoRowsOverlay();
				else gridRef.current.api.hideOverlay();
			})
			.catch(err => {
				console.log(err);
			})
	}

	useEffect(() => {
		fetchReport()
	}, [])

	const frameworkComponents = {
		customFilter: CustomFilter,
	};
	console.log('reports', reports)

	function formatData(data) {
		return data.map((item) => {
			let moduleName;
			if (item.table_name === 'service request') {
				moduleName = 'service ticket';
			} else if (item.table_name === 'service request category') {
				moduleName = 'service ticket category';
			} else if (item.table_name === 'service request status') {
				moduleName = 'service ticket status';
			} else if (item.table_name === 'service request source') {
				moduleName = 'service ticket source';
			} else {
				moduleName = item.table_name
			}
			return {
				report_name: item.report_name,
				module: moduleName,
				date_created: item.created_at ? item.created_at : '',
				...lodash.omit(item, [
					"platform_customer_id",
					"filter",
					"created_at",
					"updated_at",
					'portal',
					'user_id',
					'table_name',
					'row_model',

				]),
			}
		})
	}



	const openInNewTab = (url) => {
		window.open(url, "_blank", "noreferrer");
	};

	function onColumnRowGroupChanged(event) {
		if (event.columns.length === 0) {
			setGroupByArr([])
			setGroupByHappen(false)
		} else {
			setGroupByArr(event.columns)
			setGroupByHappen(true)
		}
	}

	const onGridReady = (params) => {
		gridRef.current = params
	}

	const onFirstDataRendered = (params) => {
		params.api.sizeColumnsToFit(4500);
		const totalRows = params.api.getDisplayedRowCount();

		if (totalRows === 0) {
			params.api.showNoRowsOverlay();
		} else {
			params.api.hideOverlay();
		}
	};

	const handleDeleteDialogOpen = (data) => {
		// handleClickOpen()
		console.log('clicled')
		setOpenDeleteDialog(true);
		setReportData(data)
	}


	const handleClose = () => {
		setOpenDeleteDialog(false);
	};



	function handleDeleteV2() {
		if (reportData.module !== undefined && reportData.report_name !== undefined) {
			axios.delete(`/reports/delete-report/${reportData.module}/${reportData.report_name}`).then((res) => {
				if (res.status === 201) {
					toast.error(res.data.message);
				}
				else {
					handleClose()
					toast.success("Report deleted successfully")
					fetchReport()
				}
			}).catch((err) => {
				console.log(err)
				toast.error(err.response.data.message)
			})
		}
	}

	function getRoutPath(name) {
		if (name === 'asset') return 'assets-list'
		if (name === 'asset category') return 'categories'
		if (name === 'accessory') return 'accessories'
		if (name === 'model attribute') return 'model-dynamic-attributes'
		if (name === 'asset status') return 'asset-statuses'
		if (name === 'accessory category') return 'accessory-categories'
		if (name === 'payment term') return 'payment-terms'
		if (name === 'contract status') return 'contract-tags'
		if (name === 'contract type') return 'contract-types'
		if (name === 'service provider') return 'service-providers'
		if (name === 'service level agreement') return 'service-level-agreements'
		if (name === 'subscription category') return 'subscription-categories'
		if (name === 'subscription status') return 'subscription-statuses'
		if (name === 'subscription provider') return 'subscription-providers'
		if (name === 'service ticket') return 'service-requests'
		if (name === 'service ticket category') return 'service-request-categories'
		if (name === 'service ticket source') return 'service-request-sources'
		if (name === 'service ticket status') return 'service-request-statuses'
		if (name === 'location type') return 'location-types'

		return `${name}s`
	}


	if (!viewReportPermission) {
		return (
			<div>
				<Card>
					<CardContent>You don't have permission to view any Reports at this time. Please contact your Systems Administrator for access.</CardContent>
				</Card>
			</div>
		)
	}

	function onFilterChanged(event) {
		const totalRows = event.api.getDisplayedRowCount();

		if (totalRows === 0) {
			event.api.showNoRowsOverlay();
		} else {
			event.api.hideOverlay();
		}
	}


	return (
		<div style={{ background: '#fff', marginBottom: '15px', padding: '28px' }}>
			<AgGridFilterGroupView
				tableRef={gridRef}
				theme="legacy"
				setRowGroupPanelShow={setRowGroupPanelShow}
				groupByArrFromList={groupByArr}
				tableName="Custom Report"
				displayTableName="Custom Report"
			/>
			<div
				className="ag-theme-alpine"
				style={{
					width: "100%",
					height: windowHeight + 105,
					fontSize: '12px',
				}}
			>
				<AgGridReact
					ref={gridRef}
					theme="legacy"
					suppressRowClickSelection
					onGridReady={onGridReady}
					onFirstDataRendered={onFirstDataRendered}
					animateRows
					rowData={reports}
					rowHeight={30}
					headerHeight={44}
					onColumnRowGroupChanged={onColumnRowGroupChanged}
					onFilterChanged={(params) => onFilterChanged(params)}
					components={frameworkComponents}
					// no rows overlay 
					overlayNoRowsTemplate="<span>No Result Found</span>"

					// Row Grouping conditions
					showOpenedGroup
					suppressDragLeaveHidesColumns
					suppressMakeColumnVisibleAfterUnGroup
					rowGroupPanelShow={rowGroupPanelShow}

					// onColumnMoved = { onColumnMoved }
					// onColumnPinned = { onColumnPinned }
					// onColumnVisible = { onColumnVisible }
					// onSortChanged = { onSortChanged }
					groupHeaderHeight={1}
					// headerHeight = {15}
					floatingFiltersHeight={40}

					// status bar enabled on range selection
					enableRangeSelection
					statusBar={{
						statusPanels: [
							{
								statusPanel: 'agAggregationComponent'
							},
						],
					}}

					// to check the the no. of rows selected during range selection
					// onRangeSelectionChanged = { onRangeSelectionChanged }						

					// onFilterChanged = { onFilterChanged }	

					// // on column group changed
					// onColumnRowGroupChanged = { onColumnRowGroupChanged }

					cacheQuickFilter

					pagination
					defaultColDef={{
						// flex: 1,
						// minWidth: 180,
						// sortable: true,
						enableRowGroup: true,
						resizable: true
					}}
					columnDefs={[
						{
							key: "report_name",
							field: "report_name",
							suppressSizeToFit: true,
							headerName: "Report Name",
							sortable: true,
							filter: "agTextColumnFilter",
							headerComponent: (props) => (CustomFilter(props, 'report_name', gridRef)),
							flex: 1,
							minWidth: 200
						}, {
							key: "module",
							field: "module",
							suppressSizeToFit: true,
							headerName: "Module",
							sortable: true,
							filter: "agTextColumnFilter",
							// floatingFilter = {true} 

							headerComponent: (props) => (CustomFilter(props, 'module', gridRef)),
							flex: 1,
							minWidth: 200,
						},
						{
							key: "date_created",
							field: "date_created",
							suppressSizeToFit: true,
							headerName: "Date Created",
							sortable: true,
							filter: "agTextColumnFilter",
							// floatingFilter = {true} 																

							headerComponent: (props) => (CustomFilter(props, 'date_created', gridRef)),
							flex: 1,
							minWidth: 200,
							cellRenderer: (event) => {
								return (
									<span>{!event.value ? event.value : dateReformatTo_mmm_dd_yyyy(event.value)}</span>
								)
							},
						},
						{
							lockPosition: true,
							rowSelection: "single",
							width: 100,
							minWidth: 100,
							maxWidth: 100,
							suppressSizeToFit: true,
							headerName: "Actions",
							suppressMenu: true,          
							suppressHeaderMenuButton: true,
							sortable: false,
							pinned: 'right',
							className: "action_field",
							lockPinned: true,
							cellRenderer: ({ data }) => {
								if (data) {
									return (
										<>
											<Tooltip id="view" title="View" placement="top">
												{/* <Icon
														onClick={()=>{openInNewTab(`/${getRoutPath(data.module)}?report_name=${data.report_name}`)}}
														fontSize="small"
														style={{
															color: '#1d2939',
															paddingBottom: "3px",
															paddingRight: "30px",
															fontSize: "15px",
															cursor: "pointer",
														}}
													>
														visibility
													</Icon> */}
												<i style={{ color: '#1D2939', fontSize: '20px', padding: '0 6px', cursor: 'pointer' }} className="ti ti-eye" onClick={() => { openInNewTab(`/${getRoutPath(data.module)}?report_name=${data.report_name}`) }} />
											</Tooltip>
											{deleteReportPermission && <Tooltip id="delete" title="Delete" placement="top">
												{/* <Icon 
													onClick={() => handleDeleteDialogOpen(data)} 
													style={{
														color: '#1d2939',
														paddingBottom: '3px',
														// paddingRight:'30px',
														fontSize:'15px',
														cursor:'pointer'
													}}
												>
													delete
												</Icon> */}
												<i style={{ color: '#1D2939', fontSize: '20px', padding: '0 6px', cursor: 'pointer' }} className="ti ti-trash" onClick={() => handleDeleteDialogOpen(data)} />
											</Tooltip>}

										</>
									);
								}
								return <></>;

							}
						}
					]}
				/>
			</div>
			{/* <DeleteModelDialog
				openDeleteDialog={openDeleteDialog}
				reportData={reportData}
				handelDelete={handelDelete}
				handleClose={handleClose}
			/> */}
			{
				openDeleteDialog &&
				<DeleteConfirmModal
					openAlerModal={openDeleteDialog}
					module="Custom Report"
					handleCloseAlertModal={handleClose}
					handleAlertModal={handleDeleteV2}
				/>
			}
		</div>
	)
}


export default withReducer('reportApp', reducer)(CustomReportLayout);
